import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DynamicFormField } from '../../../../interfaces/dynamic-form';

@Component({
  selector: 'app-dynamic-field',
  standalone: true,
  imports: [CommonModule, FormsModule],
  template: `
    <div class="form-group" [class.half]="field.larghezza === 'half'">
      <label [for]="field.nome">
        {{ field.etichetta }}
        <span class="required" *ngIf="field.obbligatorio">*</span>
      </label>

      <!-- Text -->
      <input
        *ngIf="field.blockType === 'campo-testo'"
        [id]="field.nome"
        type="text"
        [name]="field.nome"
        [placeholder]="field.placeholder || ''"
        [value]="value || ''"
        (input)="onInput($event)"
        [required]="field.obbligatorio || false"
      />

      <!-- Email -->
      <input
        *ngIf="field.blockType === 'campo-email'"
        [id]="field.nome"
        type="email"
        [name]="field.nome"
        [placeholder]="field.placeholder || ''"
        [value]="value || ''"
        (input)="onInput($event)"
        [required]="field.obbligatorio || false"
      />

      <!-- Phone -->
      <input
        *ngIf="field.blockType === 'campo-telefono'"
        [id]="field.nome"
        type="tel"
        [name]="field.nome"
        [placeholder]="field.placeholder || ''"
        [value]="value || ''"
        (input)="onInput($event)"
        [required]="field.obbligatorio || false"
      />

      <!-- Date -->
      <input
        *ngIf="field.blockType === 'campo-data'"
        [id]="field.nome"
        type="date"
        [name]="field.nome"
        [value]="value || ''"
        (input)="onInput($event)"
        [required]="field.obbligatorio || false"
      />

      <!-- Number -->
      <input
        *ngIf="field.blockType === 'campo-numero'"
        [id]="field.nome"
        type="number"
        [name]="field.nome"
        [placeholder]="field.placeholder || ''"
        [value]="value || ''"
        [min]="field.min"
        [max]="field.max"
        (input)="onInput($event)"
        [required]="field.obbligatorio || false"
      />

      <!-- Select -->
      <select
        *ngIf="field.blockType === 'campo-select'"
        [id]="field.nome"
        [name]="field.nome"
        [value]="value || ''"
        (change)="onInput($event)"
        [required]="field.obbligatorio || false"
      >
        <option value="">Seleziona...</option>
        <option *ngFor="let opt of field.opzioni" [value]="opt.valore">
          {{ opt.etichetta }}
        </option>
      </select>

      <!-- Radio -->
      <div *ngIf="field.blockType === 'campo-radio'" class="radio-options">
        <label
          *ngFor="let opt of field.opzioni"
          class="radio-option"
          [class.selected]="value === opt.valore"
        >
          <input
            type="radio"
            [name]="field.nome"
            [value]="opt.valore"
            [checked]="value === opt.valore"
            (change)="onRadioChange(opt.valore)"
          />
          <span class="radio-label">{{ opt.etichetta }}</span>
        </label>
      </div>

      <!-- Checkbox -->
      <div *ngIf="field.blockType === 'campo-checkbox'" class="checkbox-wrapper">
        <label class="checkbox-option">
          <input
            type="checkbox"
            [name]="field.nome"
            [checked]="value === true"
            (change)="onCheckboxChange($event)"
          />
          <span class="checkbox-label">{{ field.etichetta }}</span>
        </label>
      </div>

      <!-- Textarea -->
      <textarea
        *ngIf="field.blockType === 'campo-textarea'"
        [id]="field.nome"
        [name]="field.nome"
        [placeholder]="field.placeholder || ''"
        [value]="value || ''"
        (input)="onInput($event)"
        [required]="field.obbligatorio || false"
        rows="4"
      ></textarea>
    </div>
  `,
  styles: [`
    :host {
      display: block;
    }
    .form-group {
      margin-bottom: 20px;

      label {
        display: block;
        font-size: 14px;
        font-weight: 500;
        margin-bottom: 8px;
        color: var(--text, #e0e0e0);
      }
      .required {
        color: #f59e0b;
      }
      input[type="text"],
      input[type="email"],
      input[type="tel"],
      input[type="date"],
      input[type="number"],
      select,
      textarea {
        width: 100%;
        padding: 12px;
        background: var(--input-bg, #1a1a1a);
        border: 1px solid var(--input-border, #333);
        color: var(--text, #e0e0e0);
        font-size: 16px;
        font-family: inherit;
        box-sizing: border-box;
        min-height: 47px;
        -webkit-appearance: none;
        appearance: none;
        &::placeholder { color: #555; }
        &:focus { outline: none; border-color: var(--accent, #ffd65b); }
      }
      select {
        cursor: pointer;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23999' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 12px center;
        padding-right: 36px;
      }
      textarea {
        resize: vertical;
        min-height: 80px;
      }
    }
    .radio-options {
      display: flex;
      flex-direction: column;
      gap: 10px;
    }
    .radio-option {
      display: flex;
      align-items: center;
      gap: 10px;
      border: 2px solid var(--border, #333);
      padding: 12px 15px;
      cursor: pointer;
      &:hover { border-color: var(--accent, #ffd65b); }
      &.selected {
        border-color: var(--accent, #ffd65b);
        background: color-mix(in srgb, var(--accent, #ffd65b) 8%, transparent);
      }
      input[type="radio"] {
        accent-color: var(--accent, #ffd65b);
      }
      .radio-label { color: var(--text, #e0e0e0); }
      .radio-price { color: var(--text-muted, #999); font-size: 0.9em; margin-left: auto; }
    }
    .checkbox-wrapper {
      .checkbox-option {
        display: flex;
        align-items: flex-start;
        gap: 10px;
        cursor: pointer;
        input[type="checkbox"] {
          accent-color: var(--accent, #ffd65b);
          margin-top: 3px;
          width: 18px;
          height: 18px;
        }
        .checkbox-label { color: var(--text, #e0e0e0); font-size: 14px; }
      }
    }
  `],
})
export class DynamicFieldComponent {
  @Input() field!: DynamicFormField;
  @Input() value: unknown;
  @Output() valueChange = new EventEmitter<unknown>();

  onInput(event: Event): void {
    const target = event.target as HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement;
    this.valueChange.emit(target.value);
  }

  onRadioChange(valore: string): void {
    this.valueChange.emit(valore);
  }

  onCheckboxChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.valueChange.emit(target.checked);
  }

  formatPrice(cents: number): string {
    return `€${(cents / 100).toFixed(2)}`;
  }
}
